import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import InstallPrompt from "@/components/InstallPrompt";
import Home from "@/pages/Home";
import WatchRoom from "@/pages/WatchRoom";
import TermsOfService from "@/pages/TermsOfService";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

function App() {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      window.addEventListener("load", () => {
        navigator.serviceWorker.register("/service-worker.js").catch(() => {});
      });
    }
    // Fade out the branded launch splash once the app has mounted
    const splash = document.getElementById("app-splash");
    if (splash) {
      const t = setTimeout(() => {
        splash.classList.add("splash-hide");
        setTimeout(() => splash.remove(), 600);
      }, 500);
      return () => clearTimeout(t);
    }
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/room/:code" element={<WatchRoom />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <InstallPrompt />
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default App;
